import UserDetailsTestInfo from './UserDetailsTestInfo';
export default UserDetailsTestInfo;
